import React from "react";

const PrivateRoomsRowsOfRoomsOutline = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="493"
      height="1100"
      fillRule="nonzero"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeMiterlimit="10"
      clipRule="evenodd"
      version="1.1"
      viewBox="0 0 493 1100"
      xmlSpace="preserve"
      className='clickable'
    >
      <g
        fill="rgba(0,0,0,0)"
        className='object-glow'
        stroke="#ff5c97"
        strokeLinecap="round"
        strokeLinejoin="round"
        transform="translate(-2149.5 -458.5)"
      >
        <path strokeWidth="5" d="M2640 555v-92l-488-2 1 328" opacity="1"></path>
        <path strokeWidth="5" d="M2154 867v123" opacity="1"></path>
        <path strokeWidth="5" d="M2154 1170v94" opacity="1"></path>
        <path strokeWidth="5" d="M2155 1316v180" opacity="1"></path>
        <path strokeWidth="5" d="M2161 1556h67l-2-251" opacity="1"></path>
        <path strokeWidth="5" d="M2223 1104l-2-578 372 2v48" opacity="1"></path>
        <path strokeWidth="3" d="M2606 527v44" opacity="1"></path>
        <path strokeWidth="2" d="M2632 476l-32 41" opacity="1"></path>
        <path strokeWidth="2" d="M2164 474l43 37" opacity="1"></path>
        <path strokeWidth="3" d="M2216 512l384 3" opacity="1"></path>
        <path strokeWidth="3" d="M2210 521l1 573" opacity="1"></path>
        <path strokeWidth="3" d="M2212 1217v22" opacity="1"></path>
        <path strokeWidth="3" d="M2212 1306l2 245" opacity="1"></path>
      </g>
    </svg>
  );
}

export default PrivateRoomsRowsOfRoomsOutline;